import { t } from "@/i18n-js/instance";
import { useProfileDrawer } from "@/react/components/Drawers/ProfileDrawer";
import type { ChatRoomParticipant } from "@/react/types/Chat/ChatRoomParticipant";
import { usePunditUserContext } from "@circle-react/contexts";
import { UserImageStatus } from "@circle-react-shared/UserImageStatus";
import { BadgeV3 } from "@circle-react-shared/uikit/BadgeV3";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";

interface ProfileActionItem {
  color?: string;
  icon: string;
  iconClassName?: string;
  iconSize?: number;
  label: string;
  onClick: (() => void) | (() => Promise<void>);
  value: string;
}

interface ParticipantListProps {
  getProfileActionItems: (member: ChatRoomParticipant) => ProfileActionItem[];
  isViewOnlyMasquerading: boolean;
  participantList: ChatRoomParticipant[];
}

export const ParticipantList = ({
  getProfileActionItems,
  participantList,
  isViewOnlyMasquerading,
}: ParticipantListProps) => {
  const memberProfileDrawer = useProfileDrawer();
  const { currentCommunityMember } = usePunditUserContext();
  const isCurrentCommunityMemberProfile = (member: any) =>
    currentCommunityMember?.id === member.community_member_id;
  return (
    <>
      {participantList.map(member => (
        <button
          type="button"
          className="hover:bg-tertiary chat-space-rail__content--member group flex w-full cursor-pointer justify-between"
          key={member?.id}
          onClick={() => {
            if (member?.user_public_uid) {
              void memberProfileDrawer.show({
                memberPublicId: member.user_public_uid,
              });
            }
          }}
        >
          <div className="text-dark flex w-[90%] items-center text-left">
            <div className="mr-3">
              <UserImageStatus
                name={member?.name}
                src={member?.avatar_url}
                status={member?.status}
                size="8"
              />
            </div>
            <div className="truncate font-medium">
              {isCurrentCommunityMemberProfile(member)
                ? t("messaging.you")
                : member?.name}
            </div>
            {member?.community_admin ? (
              <div className="ml-3">
                <BadgeV3 label={t("admin")} isAdmin />
              </div>
            ) : (
              member?.moderator && (
                <div className="ml-3">
                  <BadgeV3 label={t("moderator")} />
                </div>
              )
            )}
          </div>
          <button
            type="button"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            {!isViewOnlyMasquerading && (
              <Dropdown
                direction="bottom-start"
                menuButtonEl="div"
                menuItemsClassName="!p-2"
                button={
                  <Dropdown.MenuButton id="action-block">
                    <IconButton
                      name="20-menu-dots-horizontal"
                      iconSize={20}
                      ariaLabel={t("chat_space.view_member_actions")}
                    />
                  </Dropdown.MenuButton>
                }
                options={getProfileActionItems(member)}
              />
            )}
          </button>
        </button>
      ))}
    </>
  );
};
